import Header from '../../components/common/global-top-bar';
import { AllSearches } from './all-searches';

export const SearchQueriesPage = () => {
  return (
    <>
      <Header heading="Search Queries" />
      <AllSearches />
    </>
  );
};
